import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleRemoveReasonTypeDetails } from "./Constant/Source";
import CreateRemoveReasonDetail from "./Forms/RemoveReasonDetailCreateForm";

const RemoveReasonCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleRemoveReasonTypeDetails.create}>
      <SimpleForm>
        <CreateRemoveReasonDetail />
      </SimpleForm>
    </Create>
  );
};

export default RemoveReasonCreate;
